import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = 'https://api1.arrowsaathi.in'; 

function App() {
  const [activeTab, setActiveTab] = useState('CONFIG'); 
  const [lines, setLines] = useState([]);
  const [selectedLineId, setSelectedLineId] = useState('');
  
  // LOGS TAB: Separate state for selecting line in Logs view
  const [selectedLogLineId, setSelectedLogLineId] = useState('');
  
  const [baths, setBaths] = useState([]);
  const [logs, setLogs] = useState([]);
  const [dashboardData, setDashboardData] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [passwordInput, setPasswordInput] = useState('');
  const FIXED_PASSWORD = "Arrowindustries@123"; 

  const [wasteStats, setWasteStats] = useState([]);
  const [wastePeriod, setWastePeriod] = useState('daily'); 
  const [tankEfficiency, setTankEfficiency] = useState([]); // NEW STATE

  const [logViewMode, setLogViewMode] = useState('TANKS'); 
  const [prodLogs, setProdLogs] = useState([]);

  const [lineColors, setLineColors] = useState({
    color_clean: '#059669', color_warning: '#D97706', color_dirty: '#DC2626', color_empty: '#374151'
  });

  const [newLineName, setNewLineName] = useState('');
  const [editingBathId, setEditingBathId] = useState(null);
  const [formData, setFormData] = useState({
    name: '', name_hindi: '', capacity_liters: 1000, shape: 'RECTANGLE', 
    row_number: 1, max_days: 3, max_lots: 500, sequence_order: 0,
    current_status: 'CLEAN', lots_accumulated_since_refill: 0,
    is_shared: 0, shared_line_ids: ''
  });

  // --- EFFECTS ---
  useEffect(() => {
    fetchLines();
    if(activeTab === 'REPORTS') {
        fetchDashboard();
        fetchWasteStats();
        fetchTankEfficiency(); // NEW FETCH
    }
  }, [activeTab, wastePeriod]);

  useEffect(() => {
    // If we switch to Logs tab and no line selected, default to first line
    if(activeTab === 'LOGS' && !selectedLogLineId && lines.length > 0) {
        setSelectedLogLineId(lines[0].id);
    }
  }, [activeTab, lines]);

  // Fetch Logs when Log Line ID changes
  useEffect(() => {
    if(activeTab === 'LOGS' && selectedLogLineId) {
        if(logViewMode === 'TANKS') fetchLogs();
        if(logViewMode === 'PRODUCTION') fetchProdLogs();
    }
  }, [selectedLogLineId, logViewMode, activeTab]);

  useEffect(() => {
    if(selectedLineId) fetchBaths();
  }, [selectedLineId]);

  // --- DATA FETCHING ---
  const fetchLines = async () => {
    try {
      const res = await axios.get(`${API_URL}/lines`);
      setLines(res.data);
      if(res.data.length > 0) {
          if(!selectedLineId) setSelectedLineId(res.data[0].id);
          if(!selectedLogLineId) setSelectedLogLineId(res.data[0].id);
      }
    } catch(e) {}
  };

  const fetchBaths = async () => {
    try {
      const res = await axios.get(`${API_URL}/line/${selectedLineId}`);
      setBaths(res.data.baths || []);
      if(res.data.line) {
        setLineColors({
          color_clean: res.data.line.color_clean || '#059669',
          color_dirty: res.data.line.color_dirty || '#DC2626',
          color_warning: res.data.line.color_warning || '#D97706',
          color_empty: res.data.line.color_empty || '#374151'
        });
      }
    } catch (e) {}
  };

  const fetchLogs = async () => {
    try {
      const res = await axios.get(`${API_URL}/line/${selectedLogLineId}/logs`);
      setLogs(res.data);
    } catch (e) {}
  };

  const fetchProdLogs = async () => {
    try {
        const res = await axios.get(`${API_URL}/line/${selectedLogLineId}/production-logs`);
        setProdLogs(res.data);
    } catch(e) {}
  };

  const fetchDashboard = async () => {
    try {
      const res = await axios.get(`${API_URL}/reports/ceo-dashboard`);
      setDashboardData(res.data);
    } catch (e) {}
  };

  const fetchWasteStats = async () => {
    try {
      const res = await axios.get(`${API_URL}/reports/waste-stats?period=${wastePeriod}`);
      setWasteStats(res.data);
    } catch (e) {}
  };
  
  const fetchTankEfficiency = async () => {
      try {
          const res = await axios.get(`${API_URL}/reports/tank-efficiency`);
          setTankEfficiency(res.data);
      } catch(e) {}
  };

  // --- HANDLERS ---
  const handleLogin = (e) => {
    e.preventDefault();
    if(passwordInput === FIXED_PASSWORD) setIsAuthenticated(true);
    else alert("Wrong Password!");
  };

  const handleCreateLine = async (e) => {
    e.preventDefault();
    await axios.post(`${API_URL}/line/create`, { name: newLineName });
    setNewLineName('');
    fetchLines();
  };

  const handleSaveBath = async (e) => {
    e.preventDefault();
    if (editingBathId) {
      await axios.put(`${API_URL}/bath/${editingBathId}`, formData);
      setEditingBathId(null);
    } else {
      await axios.post(`${API_URL}/bath/add`, { line_id: selectedLineId, ...formData });
    }
    fetchBaths();
    resetForm();
  };

  const handleEditBath = (bath) => {
    setEditingBathId(bath.id);
    setFormData({
      name: bath.name,
      name_hindi: bath.name_hindi || '',
      capacity_liters: bath.capacity_liters,
      shape: bath.shape,
      row_number: bath.row_number,
      max_days: bath.max_days,
      max_lots: bath.max_lots,
      sequence_order: bath.sequence_order || 0,
      is_shared: bath.is_shared || 0,
      shared_line_ids: bath.shared_line_ids || '', 
      current_status: bath.current_status,
      lots_accumulated_since_refill: bath.lots_accumulated_since_refill || 0
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

 const resetForm = () => {
    setFormData({
      name: '', name_hindi: '', capacity_liters: 1000, shape: 'RECTANGLE', 
      row_number: 1, max_days: 3, max_lots: 500, sequence_order: 0,
      current_status: 'CLEAN', lots_accumulated_since_refill: 0,
      is_shared: 0, shared_line_ids: ''
    });
    setEditingBathId(null);
  };

  const handleDeleteBath = async (id) => {
    if(window.confirm("Delete bath?")) { await axios.delete(`${API_URL}/bath/${id}`); fetchBaths(); }
  };

  const handleUpdateColors = async () => {
    await axios.put(`${API_URL}/line/${selectedLineId}/colors`, lineColors);
    alert("Color standards updated for this line!");
  };

  const handleDeleteLog = async (id) => {
    if(window.confirm("Delete this log entry?")) { await axios.delete(`${API_URL}/log/${id}`); fetchLogs(); }
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleEditProdLog = async (log) => {
    const newCount = prompt(`Update Lot Count for ${log.log_date}?`, log.lots_count);
    if(newCount !== null && newCount !== "" && !isNaN(newCount)) {
        await axios.put(`${API_URL}/production-log/${log.id}`, { new_lots: parseInt(newCount) });
        fetchProdLogs();
        alert("Updated & Synced!");
    }
  };

  const handleDeleteProdLog = async (id) => {
    if(window.confirm("Delete this production entry? This will REDUCE the lot count on all tanks.")) {
        await axios.delete(`${API_URL}/production-log/${id}`);
        fetchProdLogs();
    }
  };

  // --- RENDER ---
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900">
        <div className="bg-white p-8 rounded-xl shadow-2xl w-96 text-center">
          <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center font-bold text-white text-2xl mx-auto mb-4">🔒</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Hydra Admin</h2>
          <p className="text-gray-500 mb-6 text-sm">Restricted Access System</p>
          <form onSubmit={handleLogin} className="space-y-4">
            <input 
              type="password" placeholder="Enter Password" 
              className="w-full p-3 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 outline-none transition"
              value={passwordInput} onChange={(e) => setPasswordInput(e.target.value)} autoFocus
            />
            <button className="w-full bg-slate-800 text-white font-bold py-3 rounded hover:bg-slate-700 transition">UNLOCK SYSTEM</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 font-sans text-gray-800">
      <nav className="bg-slate-900 text-white p-4 shadow-lg flex justify-between items-center sticky top-0 z-50">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center font-bold">H</div>
          <h1 className="text-xl font-bold tracking-widest">HYDRA</h1>
        </div>
        <div className="flex bg-slate-800 rounded-lg p-1">
          <TabButton label="Configuration" active={activeTab==='CONFIG'} onClick={() => setActiveTab('CONFIG')} />
          <TabButton label="Logs Management" active={activeTab==='LOGS'} onClick={() => setActiveTab('LOGS')} />
          <TabButton label="CEO Dashboard" active={activeTab==='REPORTS'} onClick={() => setActiveTab('REPORTS')} />
        </div>
      </nav>

      <div className="max-w-7xl mx-auto p-6">
        
        {/* === CONFIGURATION TAB === */}
        {activeTab === 'CONFIG' && (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            <div className="lg:col-span-4 space-y-6">
              <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100">
                <h3 className="font-bold text-gray-700 mb-3">🏭 Create New Line</h3>
                <form onSubmit={handleCreateLine} className="flex gap-2">
                  <input className="flex-1 p-2 border rounded bg-gray-50 text-sm" placeholder="e.g. Zinc Plating Line 2" value={newLineName} onChange={e => setNewLineName(e.target.value)} required />
                  <button className="bg-blue-600 text-white px-4 rounded font-bold text-sm hover:bg-blue-700">+</button>
                </form>
              </div>

              <div className={`p-5 rounded-xl shadow-sm border border-gray-100 ${editingBathId ? 'bg-yellow-50 border-yellow-200' : 'bg-white'}`}>
                <div className="mb-4">
                   <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Select Active Line</label>
                   <select className="w-full p-2 border-2 border-blue-100 rounded font-bold text-blue-900" value={selectedLineId} onChange={(e) => setSelectedLineId(e.target.value)}>
                      {lines.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
                   </select>
                </div>
                <hr className="my-4"/>
                <div className="flex justify-between items-center mb-3">
                    <h3 className="font-bold text-gray-700">{editingBathId ? '✏️ Edit Tank' : '➕ Add Tank'}</h3>
                    {editingBathId && <button onClick={resetForm} className="text-xs text-red-500 underline">Cancel</button>}
                </div>
                <form onSubmit={handleSaveBath} className="space-y-3">
                  <div className="grid grid-cols-2 gap-2">
                     <input name="name" placeholder="Name (Eng)" value={formData.name} onChange={handleChange} className="w-full p-2 border rounded text-sm" required />
                     <input name="name_hindi" placeholder="Name (Hindi)" value={formData.name_hindi} onChange={handleChange} className="w-full p-2 border rounded text-sm" />
                  </div>
                  <div className="flex items-center gap-2 bg-blue-50 p-2 rounded border border-blue-100">
                     <input type="checkbox" className="w-5 h-5 accent-blue-600" checked={formData.is_shared === 1} onChange={(e) => setFormData({...formData, is_shared: e.target.checked ? 1 : 0})} />
                     <div className="text-xs text-blue-900">
                        <span className="font-bold block">COMMON / SHARED TANK</span>
                        <span className="text-[10px] text-blue-500">Visible on ALL lines (or filtered).</span>
                     </div>
                  </div>
                  {formData.is_shared === 1 && (
                      <div className="mb-3">
                          <label className="text-[10px] uppercase font-bold text-gray-500">Limit to Line IDs (Comma Separated)</label>
                          <input name="shared_line_ids" placeholder="e.g. 1,2" value={formData.shared_line_ids} onChange={handleChange} className="w-full p-2 border rounded text-sm border-blue-200 bg-blue-50" />
                      </div>
                  )}
                  <div className="grid grid-cols-2 gap-2">
                    <div><label className="text-[10px] uppercase font-bold text-gray-400">Capacity (L)</label><input name="capacity_liters" type="number" placeholder="Liters" value={formData.capacity_liters} onChange={handleChange} className="w-full p-2 border rounded text-sm" /></div>
                    <div><label className="text-[10px] uppercase font-bold text-gray-400">Shape</label><select name="shape" value={formData.shape} onChange={handleChange} className="w-full p-2 border rounded text-sm"><option value="RECTANGLE">Rectangle</option><option value="ROUND">Round</option></select></div>
                  </div>
                  <div className="grid grid-cols-3 gap-2">
                    <div><label className="text-[10px] uppercase font-bold text-gray-400">Row</label><select name="row_number" value={formData.row_number} onChange={handleChange} className="w-full p-2 border rounded text-sm"><option value="1">Row 1</option><option value="2">Row 2</option></select></div>
                    <div><label className="text-[10px] uppercase font-bold text-gray-400">Seq #</label><input name="sequence_order" type="number" value={formData.sequence_order} onChange={handleChange} className="w-full p-2 border rounded text-sm" /></div>
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <input name="max_days" type="number" placeholder="Max Days" value={formData.max_days} onChange={handleChange} className="w-full p-2 border rounded text-sm" />
                    <input name="max_lots" type="number" placeholder="Max Lots" value={formData.max_lots} onChange={handleChange} className="w-full p-2 border rounded text-sm" />
                  </div>
                  {editingBathId && (
                    <div className="bg-red-50 p-3 rounded border border-red-100 mb-3">
                      <h4 className="text-xs font-bold text-red-800 uppercase mb-2">⚠️ Manual Correction (No Log)</h4>
                      <div className="grid grid-cols-2 gap-2">
                        <div><label className="text-[10px] uppercase font-bold text-gray-500">Force Status</label><select name="current_status" value={formData.current_status} onChange={handleChange} className="w-full p-2 border rounded text-sm bg-white"><option value="CLEAN">CLEAN</option><option value="DIRTY">DIRTY</option><option value="WARNING">WARNING</option><option value="EMPTY">EMPTY</option></select></div>
                        <div><label className="text-[10px] uppercase font-bold text-gray-500">Current Lots</label><input name="lots_accumulated_since_refill" type="number" value={formData.lots_accumulated_since_refill} onChange={handleChange} className="w-full p-2 border rounded text-sm bg-white" /></div>
                      </div>
                    </div>
                  )}
                  <button className={`w-full text-white font-bold py-3 rounded transition ${editingBathId ? 'bg-yellow-600 hover:bg-yellow-700' : 'bg-slate-800 hover:bg-slate-700'}`}>{editingBathId ? 'UPDATE TANK' : 'ADD TANK'}</button>
                </form>
              </div>

              <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100">
                 <h3 className="font-bold text-gray-700 mb-3">🎨 Line Color Standards</h3>
                 <div className="grid grid-cols-2 gap-3 mb-3">
                    <div><label className="text-[10px] text-gray-500 uppercase">Clean</label><input type="color" className="w-full h-8 rounded cursor-pointer" value={lineColors.color_clean} onChange={e=>setLineColors({...lineColors, color_clean: e.target.value})}/></div>
                    <div><label className="text-[10px] text-gray-500 uppercase">Dirty</label><input type="color" className="w-full h-8 rounded cursor-pointer" value={lineColors.color_dirty} onChange={e=>setLineColors({...lineColors, color_dirty: e.target.value})}/></div>
                    <div><label className="text-[10px] text-gray-500 uppercase">Warning</label><input type="color" className="w-full h-8 rounded cursor-pointer" value={lineColors.color_warning} onChange={e=>setLineColors({...lineColors, color_warning: e.target.value})}/></div>
                    <div><label className="text-[10px] text-gray-500 uppercase">Empty</label><input type="color" className="w-full h-8 rounded cursor-pointer" value={lineColors.color_empty} onChange={e=>setLineColors({...lineColors, color_empty: e.target.value})}/></div>
                 </div>
                 <button onClick={handleUpdateColors} className="w-full bg-blue-100 text-blue-800 font-bold py-2 rounded text-sm hover:bg-blue-200">SAVE COLORS</button>
              </div>
            </div>

            <div className="lg:col-span-8 space-y-6">
               <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 min-h-[500px]">
                 <h2 className="text-lg font-bold text-gray-800 mb-6">Factory Floor Layout</h2>
                 <div className="mb-8">
                    <div className="flex items-center gap-2 mb-3"><div className="h-px bg-gray-300 flex-1"></div><span className="text-xs font-bold text-gray-400 uppercase">Row 1 (Top)</span><div className="h-px bg-gray-300 flex-1"></div></div>
                    <div className="flex gap-4 overflow-x-auto pb-4">
                      {baths.filter(b => b.row_number === 1).map(b => <BathCard key={b.id} bath={b} onDelete={handleDeleteBath} onEdit={handleEditBath} />)}
                      {baths.filter(b => b.row_number === 1).length === 0 && <EmptyRow />}
                    </div>
                 </div>
                 <div className="h-16 bg-gray-100 rounded-lg border-dashed border-2 border-gray-200 flex items-center justify-center mb-8"><span className="text-gray-400 font-bold text-sm tracking-widest">WALKWAY AREA</span></div>
                 <div>
                    <div className="flex items-center gap-2 mb-3"><div className="h-px bg-gray-300 flex-1"></div><span className="text-xs font-bold text-gray-400 uppercase">Row 2 (Bottom)</span><div className="h-px bg-gray-300 flex-1"></div></div>
                    <div className="flex gap-4 overflow-x-auto pb-4">
                      {baths.filter(b => b.row_number === 2).map(b => <BathCard key={b.id} bath={b} onDelete={handleDeleteBath} onEdit={handleEditBath} />)}
                      {baths.filter(b => b.row_number === 2).length === 0 && <EmptyRow />}
                    </div>
                 </div>
               </div>
            </div>
          </div>
        )}

        {/* === LOGS TAB (UPDATED WITH DROPDOWN) === */}
        {activeTab === 'LOGS' && (
          <div className="bg-white p-8 rounded-lg shadow min-h-[500px]">
             <div className="flex justify-between items-center mb-6">
                <div>
                    <h2 className="text-2xl font-bold text-gray-800">Line Logs</h2>
                    {/* NEW LINE SELECTOR */}
                    <div className="mt-2">
                        <label className="text-xs font-bold text-gray-500 uppercase mr-2">Select Line:</label>
                        <select className="p-2 border border-blue-200 rounded text-sm font-bold text-blue-900 bg-blue-50"
                           value={selectedLogLineId} onChange={(e) => setSelectedLogLineId(e.target.value)}>
                           {lines.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
                        </select>
                    </div>
                </div>
                <div className="flex bg-gray-100 p-1 rounded">
                    <button onClick={() => setLogViewMode('TANKS')} className={`px-4 py-2 text-sm font-bold rounded ${logViewMode==='TANKS' ? 'bg-white shadow text-blue-600' : 'text-gray-400'}`}>TANK OPERATIONS</button>
                    <button onClick={() => setLogViewMode('PRODUCTION')} className={`px-4 py-2 text-sm font-bold rounded ${logViewMode==='PRODUCTION' ? 'bg-white shadow text-green-600' : 'text-gray-400'}`}>PRODUCTION (LOTS)</button>
                </div>
             </div>
             
             {logViewMode === 'TANKS' && (
                 <table className="w-full text-left border-collapse">
                   <thead><tr className="bg-gray-100 border-b text-sm text-gray-500 uppercase"><th className="p-3">Time</th><th className="p-3">Bath Name</th><th className="p-3">Action</th><th className="p-3 text-right">Actions</th></tr></thead>
                   <tbody>
                      {logs.map(log => (
                        <tr key={log.id} className="border-b hover:bg-gray-50">
                            <td className="p-3 text-sm">{new Date(log.timestamp).toLocaleString()}</td>
                            <td className="p-3 font-medium">{log.name} <span className="text-gray-400 text-xs ml-2">({log.name_hindi})</span></td>
                            <td className="p-3"><span className={`px-2 py-1 rounded text-xs font-bold ${log.action_type==='EMPTY' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>{log.action_type}</span></td>
                            <td className="p-3 text-right"><button onClick={()=>handleDeleteLog(log.id)} className="text-red-400 hover:text-red-600 font-bold text-xs">DELETE</button></td>
                        </tr>
                      ))}
                      {logs.length === 0 && <tr><td colSpan="4" className="p-8 text-center text-gray-400">No tank logs found for this line.</td></tr>}
                   </tbody>
                 </table>
             )}

             {logViewMode === 'PRODUCTION' && (
                 <table className="w-full text-left border-collapse">
                   <thead><tr className="bg-green-50 border-b text-sm text-green-800 uppercase"><th className="p-3">Date</th><th className="p-3">Logged At</th><th className="p-3">Lots Count</th><th className="p-3 text-right">Actions</th></tr></thead>
                   <tbody>
                      {Array.isArray(prodLogs) && prodLogs.map(log => (
                        <tr key={log.id} className="border-b hover:bg-gray-50">
                            <td className="p-3 font-bold text-gray-700">{log.log_date}</td>
                            <td className="p-3 text-sm text-gray-500">{new Date(log.timestamp).toLocaleTimeString()}</td>
                            <td className="p-3 text-lg font-bold text-blue-600">{log.lots_count}</td>
                            <td className="p-3 text-right flex justify-end gap-2">
                                <button onClick={()=>handleEditProdLog(log)} className="px-3 py-1 bg-blue-100 text-blue-700 rounded text-xs font-bold hover:bg-blue-200">EDIT</button>
                                <button onClick={()=>handleDeleteProdLog(log.id)} className="px-3 py-1 bg-red-100 text-red-700 rounded text-xs font-bold hover:bg-red-200">DELETE</button>
                            </td>
                        </tr>
                      ))}
                      {(!prodLogs || prodLogs.length === 0) && <tr><td colSpan="4" className="p-8 text-center text-gray-400">No production logs found for this line.</td></tr>}
                   </tbody>
                 </table>
             )}
          </div>
        )}

        {/* === ANALYTICS TAB === */}
        {activeTab === 'REPORTS' && dashboardData && (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <KPICard title="Total Water Consumed" value={`${dashboardData.summary.total_water_liters.toLocaleString()} L`} color="blue" icon="💧" />
              <KPICard title="Total Production" value={`${dashboardData.summary.total_lots.toLocaleString()} Lots`} color="green" icon="📦" />
              <KPICard title="Global Water Efficiency" value={`${dashboardData.summary.efficiency} L/Lot`} color="purple" icon="⚡" subtitle="Total Water / Total Lots" />
            </div>

            {/* NEW: TANK EFFICIENCY REPORT */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
               <div className="p-6 border-b border-gray-100"><h3 className="font-bold text-lg text-gray-800">🚰 Water Conservation: Tank Efficiency Report</h3><p className="text-sm text-gray-500">Identify tanks that are refilled too often compared to production volume.</p></div>
               <table className="w-full text-left">
                  <thead className="bg-blue-50 text-blue-900 text-xs uppercase font-bold">
                     <tr>
                        <th className="p-4">Tank Name</th>
                        <th className="p-4">Capacity</th>
                        <th className="p-4">Total Refills</th>
                        <th className="p-4">Total Water Used</th>
                        <th className="p-4 text-center">Avg Lots/Fill</th>
                        <th className="p-4 text-right">Max Record (Best)</th> {/* NEW COLUMN */}
                     </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                     {tankEfficiency.map((row, i) => (
                        <tr key={i} className="hover:bg-blue-50">
                           <td className="p-4 font-bold text-gray-700">{row.tank_name}</td>
                           <td className="p-4 text-sm text-gray-500">{row.capacity} L</td>
                           <td className="p-4 font-bold text-red-500">{row.refills} times</td>
                           <td className="p-4 font-bold text-blue-600">{row.total_water.toLocaleString()} L</td>
                           <td className="p-4 text-center">
                               <span className={`px-2 py-1 rounded text-xs font-bold ${row.avg_lots_per_refill < 1000 ? 'bg-blue-100 text-blue-700' : 'bg-green-100 text-green-700'}`}>
                                   {row.avg_lots_per_refill.toLocaleString()}
                               </span>
                           </td>
                           {/* NEW DATA CELL */}
                           <td className="p-4 text-right">
                               <span className="px-2 py-1 rounded text-xs font-bold bg-green-100 text-green-700 border border-green-200">
                                   🏆 {row.max_lots_record.toLocaleString()}
                               </span>
                           </td>
                        </tr>
                     ))}
                     {tankEfficiency.length === 0 && <tr><td colSpan="6" className="p-6 text-center text-gray-400">No refill data available yet to calculate efficiency.</td></tr>}
                  </tbody>
               </table>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
               <div className="p-6 border-b border-gray-100 flex justify-between items-center"><h3 className="font-bold text-lg text-gray-800">🗑️ Waste Analysis</h3><div className="flex bg-gray-100 rounded p-1">{['daily', 'weekly', 'monthly'].map(p => (<button key={p} onClick={() => setWastePeriod(p)} className={`px-3 py-1 text-xs font-bold rounded uppercase ${wastePeriod === p ? 'bg-white shadow text-red-600' : 'text-gray-400'}`}>{p}</button>))}</div></div>
               <table className="w-full text-left">
                  <thead className="bg-red-50 text-red-900 text-xs uppercase font-bold"><tr><th className="p-4">Period</th><th className="p-4">Tank Name</th><th className="p-4">Times Drained</th><th className="p-4 text-right">Total Wasted</th></tr></thead>
                  <tbody className="divide-y divide-gray-100">
                     {wasteStats.map((row, i) => (<tr key={i} className="hover:bg-gray-50"><td className="p-4 font-bold text-gray-600">{row.period_date}</td><td className="p-4 font-medium">{row.tank_name}</td><td className="p-4 text-gray-500">{row.drain_count}</td><td className="p-4 text-right font-bold text-red-600">{row.total_wasted_liters.toLocaleString()} L</td></tr>))}
                  </tbody>
               </table>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
              <div className="p-6 border-b border-gray-100"><h3 className="font-bold text-lg text-gray-800">Daily Consumption Report</h3></div>
              <table className="w-full text-left">
                <thead className="bg-gray-50 text-gray-500 text-xs uppercase font-bold"><tr><th className="p-4">Date</th><th className="p-4">Line</th><th className="p-4">Lots Produced</th><th className="p-4">Drains</th><th className="p-4">Refills</th><th className="p-4 text-right">Water Used</th></tr></thead>
                <tbody className="divide-y divide-gray-100">
                  {dashboardData.daily_breakdown.map((row, i) => (
                    <tr key={i} className="hover:bg-blue-50 transition">
                      <td className="p-4 font-medium text-gray-700">{row.date}</td>
                      <td className="p-4 text-gray-600">{row.line_name}</td>
                      <td className="p-4 font-bold text-gray-800">{row.lots_produced || 0}</td>
                      <td className="p-4 text-red-500">{row.drains}</td>
                      <td className="p-4 text-green-600">{row.refills}</td>
                      <td className="p-4 text-right font-bold text-blue-600">{row.water_consumed_liters.toLocaleString()} L</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const TabButton = ({ label, active, onClick }) => (<button onClick={onClick} className={`px-6 py-2 rounded-md text-sm font-bold transition-all ${active ? 'bg-white text-slate-900 shadow' : 'text-gray-400 hover:text-white'}`}>{label}</button>);
const KPICard = ({ title, value, color, icon, subtitle }) => (<div className={`bg-white p-6 rounded-xl shadow-sm border-l-4 border-${color}-500`}><div className="flex justify-between items-start"><div><p className="text-gray-500 text-sm font-bold uppercase">{title}</p><h3 className="text-3xl font-bold text-gray-800 mt-1">{value}</h3>{subtitle && <p className="text-xs text-gray-400 mt-2">{subtitle}</p>}</div><div className={`text-2xl bg-${color}-100 w-12 h-12 flex items-center justify-center rounded-full`}>{icon}</div></div></div>);
const BathCard = ({ bath, onDelete, onEdit }) => (<div onClick={() => onEdit(bath)} className="min-w-[120px] p-3 border rounded-lg bg-gray-50 relative group cursor-pointer hover:bg-blue-50 border-gray-200 hover:border-blue-300 transition"><button onClick={(e) => { e.stopPropagation(); onDelete(bath.id); }} className="absolute top-1 right-1 text-red-300 hover:text-red-500 font-bold px-1">×</button><div className={`mx-auto w-16 h-12 mb-2 bg-blue-200 border-2 border-blue-300 ${bath.shape === 'ROUND' ? 'rounded-full' : 'rounded-md'}`}></div><div className="text-center"><div className="font-bold text-xs truncate">{bath.name}</div><div className="text-[10px] text-gray-400 truncate">{bath.name_hindi}</div><div className="text-[9px] text-gray-500 mt-1">Seq: {bath.sequence_order} | {bath.capacity_liters}L</div></div></div>);
const EmptyRow = () => <div className="text-sm text-gray-400 italic p-4">No tanks in this row yet.</div>;

export default App;